/**
 * Team & Access Hub.
 *
 * User management and activity log in a focused tabbed interface.
 * Handles user creation, role assignment, and audit trail review.
 */

import { Link } from "react-router-dom";
import { Users, ClipboardList, ArrowLeft } from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import UserManagementPage from "@/pages/UserManagementPage";
import ActivityFeedPage from "@/pages/ActivityFeedPage";

const tabs = [
  { key: "users", label: "Users", icon: Users },
  { key: "activity", label: "Activity Log", icon: ClipboardList },
];

function AdminTeamHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "users");

  return (
    <div className="page-content space-y-6">
      <div className="flex items-start gap-4">
        <Link
          to="/admin"
          className="mt-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-secondary)] transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h2 className="text-2xl font-bold text-[var(--text-primary)]">
            Team & Access
          </h2>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">
            Manage users, permissions, and review the audit trail.
          </p>
        </div>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "users" && <UserManagementPage />}
      {activeTab === "activity" && <ActivityFeedPage />}
    </div>
  );
}

export default AdminTeamHub;
